import {
  GEOGRAPHIC_CRITERIA_TYPE,
  RATE_TYPE,
  RULE_ACTION,
  PARENT_EQUIPMENT_KEY,
  SPOT_PREMIUM_TYPE,
  ONLY_BID_ON_CRITERIA,
  CONDITION_QUALIFIER,
  MODIFY_PAST_PICKUP,
  DAY_OR_HOUR,
} from '../types/spotBiddingConfig'

export enum DATE_TYPE {
  sameDay = 'sameDay',
  weekend = 'weekend',
  dateRange = 'dateRange',
  numDaysOut = 'numDaysOut',
}

export const QUOTE_TYPE_OPTIONS = [
  {
    label: 'All-in',
    value: RATE_TYPE.allIn,
  },
  {
    label: 'Linehaul',
    value: RATE_TYPE.linehaul,
  },
]

export const MODIFY_PP_TYPE_OPTIONS = [
  {
    label: 'Do Not Bid',
    value: MODIFY_PAST_PICKUP.doNotBid,
  },
  {
    label: 'Set to Today',
    value: MODIFY_PAST_PICKUP.setToToday,
  },
  {
    label: 'Set to Tomorrow',
    value: MODIFY_PAST_PICKUP.setToTomorrow,
  },
  {
    label: 'Set to 2 Business Days from now',
    value: MODIFY_PAST_PICKUP.setToTwoDays,
  },
]

export const GEO_TYPE_OPTIONS = [
  {
    label: 'State',
    value: GEOGRAPHIC_CRITERIA_TYPE.state,
  },
  {
    label: 'City, State',
    value: GEOGRAPHIC_CRITERIA_TYPE.cityState,
  },
  {
    label: 'DAT Market',
    value: GEOGRAPHIC_CRITERIA_TYPE.datMarket,
  },
]

export const RULE_ACTION_OPTIONS = [
  {
    label: 'Apply Premium',
    value: RULE_ACTION.applyPremium,
  },
  {
    label: "Don't Bid",
    value: RULE_ACTION.dontBid,
  },
  {
    label: 'Only Bid On',
    value: RULE_ACTION.onlyBidOn,
  },
]

export const RULE_TYPE_OPTIONS = [
  {
    label: 'Baseline',
    value: 'baseline',
  },
  {
    label: 'Outbound (PU)',
    value: 'outbound',
  },
  {
    label: 'Inbound (DEL)',
    value: 'inbound',
  },
  {
    label: 'Lane (PU + DEL)',
    value: 'lane',
  },
  {
    label: 'Step Pricing',
    value: 'count',
  },
  {
    label: 'Mileage',
    value: 'mileage',
  },
  {
    label: 'Contract',
    value: 'contract',
  },
  {
    label: 'Distance to Market Center',
    value: 'distance',
  },
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'Equipment',
    value: 'equipment',
  },
  {
    label: 'Appointment (PU)',
    value: 'appointmentPickup',
  },
  {
    label: 'Appointment (DEL)',
    value: 'appointmentDelivery',
  },
  {
    label: 'Transit',
    value: 'transit',
  },
  {
    label: 'Drop Only',
    value: 'isDrop',
  },
  {
    label: 'Stop Specific Drop',
    value: 'stopSpecificDrop',
  },
  {
    label: 'Transit Difference',
    value: 'transitDifference',
  },
]

export const DTMC_RANGE_OPTIONS = [
  {
    label: 'Less Than',
    value: 'less',
  },
  {
    label: 'More Than or Equal to',
    value: 'more',
  },
  {
    label: 'Between',
    value: 'between',
  },
]

export const DTMC_LOCATION_TYPE_OPTIONS = [
  {
    label: 'Pickup',
    value: 'pickup',
  },
  {
    label: 'Delivery',
    value: 'delivery',
  },
]

export const AWARD_TYPE_OPTIONS = [
  {
    label: 'Primary',
    value: 'primary',
  },
  {
    label: 'Backup',
    value: 'backup',
  },
  {
    label: 'Published',
    value: 'published',
  },
]

export const MILEAGE_TYPE_OPTIONS = [
  {
    label: 'Less Than',
    value: 'less',
  },
  {
    label: 'More Than or Equal to',
    value: 'more',
  },
  {
    label: 'Between',
    value: 'between',
  },
]

export const TRANSIT_DIFFERENCE_TYPE_OPTIONS = [
  {
    label: 'Less Than',
    value: 'less',
  },
  {
    label: 'More Than or Equal to',
    value: 'more',
  },
  {
    label: 'Between',
    value: 'between',
  },
]

export const COUNT_LOADS_RANGE_OPTIONS = [
  {
    label: 'Less Than',
    value: 'less',
  },
  {
    label: 'More Than or Equal to',
    value: 'more',
  },
  {
    label: 'Between',
    value: 'between',
  },
]

export const DATE_TYPE_OPTIONS = [
  {
    label: 'Same Day',
    value: DATE_TYPE.sameDay,
  },
  {
    label: 'Weekend',
    value: DATE_TYPE.weekend,
  },
  {
    label: 'Specific Date or Range',
    value: DATE_TYPE.dateRange,
  },
  {
    label: 'Number of Hours/Days Out',
    value: DATE_TYPE.numDaysOut,
  },
]

export const PREMIUM_TYPE_OPTIONS = [
  {
    label: 'Percentage',
    value: SPOT_PREMIUM_TYPE.percentage,
  },
  {
    label: 'Total Dollars',
    value: SPOT_PREMIUM_TYPE.total,
  },
]

export const CONDITION_QUALIFIER_OPTIONS = [
  {
    label: 'Is',
    value: CONDITION_QUALIFIER.is,
  },
  {
    label: 'Is not',
    value: CONDITION_QUALIFIER.isNot,
  },
]

export const DAY_OR_HOUR_OPTIONS = [
  {
    value: DAY_OR_HOUR.hours,
    label: 'Hours',
  },
  {
    value: DAY_OR_HOUR.days,
    label: 'Day(s)',
  },
]

export const ONLY_BID_ON_OPTIONS = [
  {
    label: 'Drop',
    value: ONLY_BID_ON_CRITERIA.drop,
  },
  {
    label: 'Weekend',
    value: ONLY_BID_ON_CRITERIA.weekend,
  },
  {
    label: 'Same Day',
    value: ONLY_BID_ON_CRITERIA.sameDay,
  },
  {
    label: 'Multi Stop',
    value: ONLY_BID_ON_CRITERIA.multiStop,
  },
]

export const EQUIPMENT_OPTIONS = [
  {
    label: 'Dry Van',
    value: PARENT_EQUIPMENT_KEY.dryVan,
  },
  {
    label: 'Reefer',
    value: PARENT_EQUIPMENT_KEY.reefer,
  },
]

export enum DATE_RANGE_TYPE {
  MORE = 'more',
  LESS = 'less',
  EXACTLY = 'exactly',
}

export const DATE_RANGE_TYPE_OPTIONS = [
  {
    label: 'Less Than',
    value: DATE_RANGE_TYPE.LESS,
  },
  {
    label: 'More Than',
    value: DATE_RANGE_TYPE.MORE,
  },
  {
    label: 'Exactly',
    value: DATE_RANGE_TYPE.EXACTLY,
  },
]

export enum APPLICABLE_DURING_TYPE {
  INDEFINITELY = 'indefinitely',
  NUM_DAYS_OUT = 'numDaysOut',
}

export const APPLICABLE_DURING_OPTIONS = [
  {
    label: 'Indefinitely',
    value: APPLICABLE_DURING_TYPE.INDEFINITELY,
  },
  {
    label: 'Number of Days Out',
    value: APPLICABLE_DURING_TYPE.NUM_DAYS_OUT,
  },
]

export enum HAUL_TYPE {
  LOCAL = 'local',
  NON_LOCAL = 'nonLocal',
}

export enum APPOINTMENT_TYPE {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}

export const APPOINTMENT_TYPE_OPTIONS = [
  {
    label: 'Pickup',
    value: APPOINTMENT_TYPE.PICKUP,
  },
  {
    label: 'Delivery',
    value: APPOINTMENT_TYPE.DELIVERY,
  },
]

export const HAUL_TYPE_OPTIONS = [
  {
    label: 'Local (1-200 mi)',
    value: HAUL_TYPE.LOCAL,
  },
  {
    label: 'Non Local (+200 mi)',
    value: HAUL_TYPE.NON_LOCAL,
  },
]

export const APPOINTMENT_TIME_OPTIONS = {
  [APPOINTMENT_TYPE.PICKUP]: {
    [HAUL_TYPE.LOCAL]: [
      {
        label: '07:00-15:00',
        value: '07:00-15:00',
      },
      {
        label: '15:00-20:00',
        value: '15:00-20:00',
      },
      {
        label: '20:00-07:00',
        value: '20:00-07:00',
      },
    ],
    [HAUL_TYPE.NON_LOCAL]: [
      {
        label: '09:00-11:00',
        value: '09:00-11:00',
      },
      {
        label: '11:00-20:00',
        value: '11:00-20:00',
      },
      {
        label: '20:00-23:00',
        value: '20:00-23:00',
      },
      {
        label: '23:00-09:00',
        value: '23:00-09:00',
      },
    ],
  },
  [APPOINTMENT_TYPE.DELIVERY]: {
    [HAUL_TYPE.LOCAL]: [
      {
        label: '07:00-15:00',
        value: '07:00-15:00',
      },
      {
        label: '15:00-20:00',
        value: '15:00-20:00',
      },
      {
        label: '20:00-07:00',
        value: '20:00-07:00',
      },
    ],
    [HAUL_TYPE.NON_LOCAL]: [
      {
        label: '04:00-06:00',
        value: '04:00-06:00',
      },
      {
        label: '06:00-12:00',
        value: '06:00-12:00',
      },
      {
        label: '12:00-16:00',
        value: '12:00-16:00',
      },
      {
        label: '16:00-04:00',
        value: '16:00-04:00',
      },
    ],
  },
}

export const TRANSIT_TIME_OPTIONS = [
  {
    label: '< 0',
    value: '-0',
  },
  {
    label: '0 to 3',
    value: '0-3',
  },
  {
    label: '3 or more',
    value: '3-',
  },
]
